import { createReducer, on } from "@ngrx/store";
import {
  fetchPayments,
  fetchPaymentsSuccess,
  fetchPaymentsFailure,
  getPayment,
  getPaymentSuccess,
  getPaymentFailure
} from "./payment.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0
};

const _paymentReducer = createReducer(
  initialState,
  on(fetchPayments, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchPaymentsSuccess, (state, { payments }) => {
    const payload = {
      isLoaded: true,
      data: payments.data,
      total: payments.total,
      maxPages: payments.maxPages,
      perPage: payments.perPage,
      currentPage: payments.currentPage,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchPaymentsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(getPayment, (state, { paymentID }) => {
    return state;
  }),
  on(getPaymentSuccess, (state, { payment }) => {
    const payload = {
      selectedItem: payment
    };
    return { ...state, ...payload };
  }),
  on(getPaymentFailure, (state, { error }) => {
    const payload = {
      error
    };
    return { ...state, ...payload };
  })
);

export function paymentReducer(state, action) {
  return _paymentReducer(state, action);
}
